export const AUTH_TYPE = {
  PASSWORD: 'PASSWORD',
  GOOGLE: 'GOOGLE',
  SAML: 'SAML',
  OPENID: 'OPENID',
};
